// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { sparseCustomerSchema } from '@/sparse/api/types';
import { dateTimeSchema } from '@/utilities/date-time-schema';
import { z } from 'zod';

export const contactSchema = z.object({
  id: z.string(),
  key: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  title: z.string().nullable(),
  comments: z.string().nullable(),
  isArchived: z.boolean(),
  customer: sparseCustomerSchema,
  createdAt: dateTimeSchema,
  updatedAt: dateTimeSchema,
});

export type Contact = z.infer<typeof contactSchema>;

export interface CreateContactParameters {
  firstName: string;
  lastName: string;
  customerId: string;
  email?: string | null;
  phone?: string | null;
  title?: string | null;
  comments?: string | null;
}

export interface UpdateContactParameters {
  firstName?: string;
  lastName?: string;
  customerId?: string;
  email?: string | null;
  phone?: string | null;
  title?: string | null;
  comments?: string | null;
  isArchived?: boolean;
}
